module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-hill-ea47b396fd01e9e2394ee023be2869f8.svg";